import { Injectable } from '@angular/core';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { CutoffDatePreCheckError } from '../../../errors/pre-check/cutoff-date-pre-check-error';
import { IPurePickValidator } from './validators';

@Injectable()
export class PickClosedValidator implements IPurePickValidator<CutoffDatePreCheckError> {
    validate(pick: BetslipPick): CutoffDatePreCheckError[] {
        if (BetslipV1Pick.isPick(pick) || BetslipV2OptionMarketPick.isPick(pick)) {
            if (pick.market.isClosed) {
                return [new CutoffDatePreCheckError(pick.id.toString(), new Date())];
            }
        }

        return [];
    }
}
